import { render, staticRenderFns } from "./SupplierForm.vue?vue&type=template&id=2a31e65f&scoped=true&"
import script from "./SupplierForm.vue?vue&type=script&lang=js&"
export * from "./SupplierForm.vue?vue&type=script&lang=js&"
import style0 from "./SupplierForm.vue?vue&type=style&index=0&id=2a31e65f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a31e65f",
  null
  
)

export default component.exports